import { StoreAction, XmAction } from 'store/actions';
import { Breeze } from './models';

export function breezeReducer(state: Breeze, action: XmAction<Breeze>): Breeze {
    switch (action.type) {
        case StoreAction.POST_BREEZE:
            return action.payload;
        default:
            return state;
    }
}
